import React from "react";
import IsNewClaimForCondition from "./IsNewClaimForCondition";
import QueryWithTwoOptions from "../shared/QueryWithTwoOptions";
import {
  CHEMOTHERAPY,
  RADIOTHERAPY,
  CHEMO_RADIO_THERAPY_CONTENT
} from "./Constants";
import { updateMakeAClaimProperties } from "../../actions/makeAClaim/MakeAClaimActions";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import CheckListForClaimBack from "./CheckListForClaimBack";
import Store from "./../../content/Store";
import GetStartedButton from "./GetStartedButton";
import styles from "./../../../src/assets/css/modules/makeAClaim/chemo-radio-therapy.css";
import PromptMessageForCashBenefit from "./PromptMessageForCashBenefit";
import Scroll from "react-scroll";

export const ChemotherapyOrRadiotherapyTreatment = ({
  isNewClaim,
  nhsChemoRadioTreatmentType,
  content,
  updateMakeAClaimProperties
}) => {
  return (
    <React.Fragment>
      <div className="mt-5">
        <IsNewClaimForCondition />
        {isNewClaim && <PromptMessageForCashBenefit />}
      </div>
      {isNewClaim === false && (
        <div className={styles.inputWrapper}>
          <QueryWithTwoOptions
            query={content.label}
            option1Label={content.option1}
            option2Label={content.option2}
            option1OnClickHandler={() => {
              updateMakeAClaimProperties({
                nhsChemoRadioTreatmentType: CHEMOTHERAPY
              });
              scrollToName();
            }}
            option2OnClickHandler={() => {
              updateMakeAClaimProperties({
                nhsChemoRadioTreatmentType: RADIOTHERAPY
              });
              scrollToName();
            }}
            buttonType="transversalButton"
            optionTwoIsSelected={isOptionTwoSelected(
              nhsChemoRadioTreatmentType
            )}
          />
        </div>
      )}
      <div name={CHEMO_RADIO_THERAPY_CONTENT} className={styles.inputWrapper}>
        {nhsChemoRadioTreatmentType && (
          <React.Fragment>
            <CheckListForClaimBack
              content={
                nhsChemoRadioTreatmentType === RADIOTHERAPY
                  ? content.Radiotherapy
                  : content.Chemotherapy
              }
            />
            <GetStartedButton />
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

function isOptionTwoSelected(nhsChemoRadioTreatmentType) {
  if (typeof nhsChemoRadioTreatmentType === "string") {
    return nhsChemoRadioTreatmentType === RADIOTHERAPY;
  }
  return null;
}

function scrollToName() {
  Scroll.scroller.scrollTo(CHEMO_RADIO_THERAPY_CONTENT, {
    duration: 750,
    smooth: true
  });
}

export const mapStateToChemotherapyOrRadiotherapyTreatment = ({
  makeAClaimReducer
}) => {
  const { isNewClaim, nhsChemoRadioTreatmentType } = makeAClaimReducer;
  return {
    isNewClaim,
    nhsChemoRadioTreatmentType
  };
};

ChemotherapyOrRadiotherapyTreatment.content = {
  ...Store.ClaimBackChemoOrRadiotherapy,
  Radiotherapy: Store.Radiotherapy,
  Chemotherapy: Store.Chemotherapy
};

export default connect(mapStateToChemotherapyOrRadiotherapyTreatment, {
  updateMakeAClaimProperties
})(Contentify(ChemotherapyOrRadiotherapyTreatment));
